// material
import { Box, Container, Grid } from "@material-ui/core";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { config as url } from "../../common/config";
// import jwtDecode from 'jwt-decode'
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import {
	AppChartsKeterangan,
	AppIssues,
	AppProgress,
	AppSelesai,
	AppTodo,
	AppTotal,
	AppFinish,
	AppTable,
	AppTableCompare,
} from "./components";
// components
import Page from "./page";

export default function DashboardApp() {
	const BaseUrl = `${url.dashboard}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDashboard,
		getDataTables,
		// refreshDataCompare,
		// tableRef,
		// tableRefCompare,
	} = fetchData;
	const [loading, setLoading] = useState(false);
	const [clicked, setClicked] = useState(false);

	const [CountDashboards, setCountDashboards] = useState({
		total: "",
		open: "",
		onProgress: "",
		done: "",
		finish: "",
	});
	const [CountBar, setCountBar] = useState({
		labels: [],
		datasets: [],
	});
	const [CountLine, setCountLine] = useState({
		labels: [],
		datasets: [],
	});

	const [stateDate, setStateDate] = useState({
		tgl_awal: moment().startOf("month").format("YYYY-MM-DD"),
		tgl_akhir: moment().format("YYYY-MM-DD"),
	});
	const [stateDateCompare, setStateDateCompare] = useState({
		tgl_awal: moment().startOf("month").format("YYYY-MM-DD"),
		tgl_akhir: moment().format("YYYY-MM-DD"),
	});

	const HandleClickedTable = (value) => {
		setClicked(value);
		setStateDateCompare({
			...stateDateCompare,
			tgl_awal: moment(stateDate.tgl_awal)
				.add(-1, "months")
				.format("YYYY-MM-DD"),
			tgl_akhir: moment(stateDate.tgl_akhir)
				.add(-1, "months")
				.format("YYYY-MM-DD"),
		});
	};

	const loadData = async () => {
		try {
			setLoading(true);
			let CountDashboard = await getDashboard({ url: `${BaseUrl}/issue` });
			if (CountDashboard) {
				setCountDashboards({
					total: CountDashboard.issue,
					open: CountDashboard.open,
					onProgress: CountDashboard.progress,
					done: CountDashboard.close,
					finish: CountDashboard.finish,
				});
				setLoading(false);
			}
		} catch (error) {
			return error;
		}
	};

	const loadDataCharts = async () => {
		try {
			setLoading(true);
			let ChartsBar = await getDashboard({ url: `${BaseUrl}/issue_bar` });
			if (ChartsBar) {
				setCountBar({
					labels: ChartsBar.labels,
					datasets: ChartsBar.data,
				});
				setLoading(false);
			}
		} catch (error) {
			return error;
		}
	};

	const loadDataChartLine = async () => {
		try {
			let ChartsLine = await getDashboard({ url: `${BaseUrl}/issue_line` });
			if (ChartsLine)
				setCountLine({
					labels: ChartsLine.labels,
					datasets: ChartsLine.series,
					child: ChartsLine.child,
				});
		} catch (error) {
			throw error;
		}

		return {};
	};

	useEffect(() => {
		loadDataCharts();
		loadDataChartLine();
		loadData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Page title="Dashboard | Ticketing Helpdesk">
			<Container maxWidth="false" style={{ backgroundColor: "#f7f7f7" }}>
				<Box sx={{ pb: 1 }}></Box>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6} md={4}>
						<AppTotal issue={CountDashboards?.total} />
					</Grid>
					<Grid item xs={12} sm={6} md={2}>
						<AppTodo open={CountDashboards?.open} />
					</Grid>
					<Grid item xs={12} sm={6} md={2}>
						<AppProgress onProgress={CountDashboards?.onProgress} />
					</Grid>
					<Grid item xs={12} sm={6} md={2}>
						<AppFinish finish={CountDashboards?.finish} />
					</Grid>
					<Grid item xs={12} sm={12} md={2}>
						<AppSelesai done={CountDashboards?.done} />
					</Grid>
					<Grid item xs={12} md={6} lg={6}>
						<AppChartsKeterangan CountLine={CountLine && CountLine} />
					</Grid>
					<Grid item xs={12} md={6} lg={6}>
						<AppIssues CountBar={CountBar && CountBar} loading={loading} />
					</Grid>
					<Grid item xs={12} md={clicked ? 6 : 12} lg={clicked ? 6 : 12}>
						<AppTable
							getDataTables={getDataTables}
							HandleClickedTable={HandleClickedTable}
							state={stateDate}
							setState={setStateDate}
						/>
					</Grid>
					{clicked && (
						<Grid item xs={12} md={6} lg={6}>
							<AppTableCompare
								type="Perbandingan Tiker Per Kategori"
								getDataTables={getDataTables}
								HandleClickedTable={HandleClickedTable}
								state={stateDateCompare}
								setState={setStateDateCompare}
							/>
						</Grid>
					)}
				</Grid>
			</Container>
		</Page>
	);
}
